import React, {useState } from "react";
import ScraperModuleFormField from "./ScraperModuleFormField";


const AddScraperModule = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Scraper Modules", url: "/scrapers-modules" },
        { content: "Add Scraper Module", url: "" }
    ])

    return (
        <>
            <ScraperModuleFormField crumbs={crumbs} title={"Add Scraper Module"} btnText={"Create"} />
        </>
    )

}
export default AddScraperModule;